'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import type * as React from 'react';
import { useState } from 'react';
import { AnimatedButton } from '@/components/ui/animated-button';
import { InputField } from '@/components/ui/input-field';
import { EarnCard } from './earn-card';
import { useRewardsTips } from './info-tip';
import { PostsButton } from './posts-button';
interface PostCardProps {
  capsRemaining?: number | undefined;
  onSubmit: (value: string) => void;
  busy?: boolean | undefined;
  /** The participant's rewards referral link, injected into the post ideas' CTAs. */
  referralLink?: string | undefined;
}
const POST_DAILY_CAP = 5;
export function PostCard(t0) {
  const $ = _c(41);
  const {
    capsRemaining,
    onSubmit,
    busy,
    referralLink
  } = t0;
  const t = useTranslations("rewards");
  const tips = useRewardsTips();
  const [value, setValue] = useState("");
  const used = POST_DAILY_CAP - (capsRemaining ?? POST_DAILY_CAP);
  const completed = used >= POST_DAILY_CAP;
  let t1;
  if ($[0] !== completed || $[1] !== onSubmit || $[2] !== value) {
    t1 = () => {
      if (completed) {
        return;
      }
      const trimmed = value.trim();
      if (trimmed === "") {
        return;
      }
      onSubmit(trimmed);
      setValue("");
    };
    $[0] = completed;
    $[1] = onSubmit;
    $[2] = value;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const submit = t1;
  let t2;
  if ($[4] !== t) {
    t2 = t("post.title");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = tips.post;
  let t4;
  if ($[6] !== referralLink) {
    t4 = <PostsButton referralLink={referralLink} />;
    $[6] = referralLink;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("post.pill");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t("post.description");
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = used / POST_DAILY_CAP * 100;
  const t8 = `${used}/${POST_DAILY_CAP}`;
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = e => setValue(e.target.value);
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t) {
    t10 = t("post.placeholder");
    $[13] = t;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== completed || $[16] !== t10 || $[17] !== value) {
    t11 = <InputField fullWidth={true} containerClassName="flex-1" value={value} onChange={t9} placeholder={t10} disabled={completed} />;
    $[15] = completed;
    $[16] = t10;
    $[17] = value;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  const t12 = busy || completed;
  let t13;
  if ($[19] !== t) {
    t13 = t("post.submit");
    $[19] = t;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t) {
    t14 = t("post.submit");
    $[21] = t;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== busy || $[24] !== submit || $[25] !== t12 || $[26] !== t13 || $[27] !== t14) {
    t15 = <AnimatedButton variant="secondary" data-testid="submit-post" onClick={submit} disabled={t12} loading={busy} aria-label={t13}>{t14}</AnimatedButton>;
    $[23] = busy;
    $[24] = submit;
    $[25] = t12;
    $[26] = t13;
    $[27] = t14;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t11 || $[30] !== t15) {
    t16 = <div className="flex items-center gap-2">{t11}{t15}</div>;
    $[29] = t11;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t16 || $[33] !== t2 || $[34] !== t4 || $[35] !== t5 || $[36] !== t6 || $[37] !== t7 || $[38] !== t8 || $[39] !== tips.post) {
    t17 = <EarnCard data-testid="post-card" title={t2} tip={t3} titleAdornment={t4} points={t5} description={t6} progress={t7} progressLabel={t8}>{t16}</EarnCard>;
    $[32] = t16;
    $[33] = t2;
    $[34] = t4;
    $[35] = t5;
    $[36] = t6;
    $[37] = t7;
    $[38] = t8;
    $[39] = tips.post;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  return t17;
}